import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface HasData<T> {
  data?: T;
}

export const responseData = <T>(src$: Observable<HasData<T>>) =>
  src$.pipe(map(response => response.data as NonNullable<T>));
